import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { useTranslation } from 'react-i18next';
import { ToastProvider } from '@hostfully/ui-components';
import { DesignSystemThemeProvider } from '@hostfully/ui-components/theme';
import Router from '@/router';
import GlobalStyles from '@/styles/GlobalStyles';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      retry: false,
      enabled: false,
    },
  },
});

const App = () => {
  const { t } = useTranslation();
  return (
    <QueryClientProvider client={queryClient}>
      <DesignSystemThemeProvider>
        <GlobalStyles />
        <ToastProvider closeAriaLabel={t('common.toast.dismiss')}>
          <Router />
        </ToastProvider>
      </DesignSystemThemeProvider>
      <ReactQueryDevtools />
    </QueryClientProvider>
  );
};

export default App;
